import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
export const DrawerButton = ({ label, onClick, testId, startIcon, variant = 'outlined', size = 'medium' }) => {
    return (_jsx(Button, { "data-testid": testId, onClick: onClick, variant: variant, size: size, startIcon: startIcon, fullWidth: true, children: label }));
};
